import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _classPrivateFieldLooseBase from '@babel/runtime/helpers/esm/classPrivateFieldLooseBase';
import _classPrivateFieldLooseKey from '@babel/runtime/helpers/esm/classPrivateFieldLooseKey';

var _startTime = /*#__PURE__*/_classPrivateFieldLooseKey("startTime");
var _acumulatedTime = /*#__PURE__*/_classPrivateFieldLooseKey("acumulatedTime");
/**
 * Allows to measure elapsed time
 */
var TimeCounter = /*#__PURE__*/function () {
  function TimeCounter() {
    _classCallCheck(this, TimeCounter);
    Object.defineProperty(this, _startTime, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _acumulatedTime, {
      writable: true,
      value: 0
    });
  }
  _createClass(TimeCounter, [{
    key: "getElapsedMilliseconds",
    value:
    /**
     * Returns the elapsed time in milliseconds
     * @returns {number} The elapsed milliseconds.
     */
    function getElapsedMilliseconds() {
      var ellapsedFromLastStart = _classPrivateFieldLooseBase(this, _startTime)[_startTime] ? Date.now() - _classPrivateFieldLooseBase(this, _startTime)[_startTime] : 0;
      return _classPrivateFieldLooseBase(this, _acumulatedTime)[_acumulatedTime] + ellapsedFromLastStart;
    }

    /**
     * Returns the elapsed time in seconds.
     * @return {number} The elapsed seconds.
     */
  }, {
    key: "getElapsedSeconds",
    value: function getElapsedSeconds() {
      return Math.floor(this.getElapsedMilliseconds() / 1000);
    }

    /**
     * Starts the time counter.
     */
  }, {
    key: "start",
    value: function start() {
      if (!_classPrivateFieldLooseBase(this, _startTime)[_startTime]) {
        _classPrivateFieldLooseBase(this, _startTime)[_startTime] = Date.now();
      }
    }

    /**
     * Stops the time counter.
     */
  }, {
    key: "stop",
    value: function stop() {
      _classPrivateFieldLooseBase(this, _acumulatedTime)[_acumulatedTime] = this.getElapsedMilliseconds();
      _classPrivateFieldLooseBase(this, _startTime)[_startTime] = undefined;
    }

    /**
     * Resets the time counter.
     */
  }, {
    key: "reset",
    value: function reset() {
      _classPrivateFieldLooseBase(this, _acumulatedTime)[_acumulatedTime] = 0;
      _classPrivateFieldLooseBase(this, _startTime)[_startTime] = undefined;
    }
  }]);
  return TimeCounter;
}();

export { TimeCounter };
//# sourceMappingURL=TimeCounter.js.map
